import React, { ReactNode } from 'react';

import { CookieConsentProvider } from '@/context/CookieConsentContext';
import { PageCustomizationProvider } from '@/context/PageCustomizationContext';
import { IsSearchingProvider } from '@/context/IsSearchingContext';
import ReactQueryProvider from './ReactQueryProvider';
import { Network, NetworkProvider } from '@keytrade/network';

type ChildrenOnly = {
  children: ReactNode;
};

const AppProviders = ({ children }: ChildrenOnly): ReactNode => (
  <NetworkProvider Network={Network}>
    <PageCustomizationProvider>
      <CookieConsentProvider>
        <IsSearchingProvider>
          <ReactQueryProvider>{children}</ReactQueryProvider>
        </IsSearchingProvider>
      </CookieConsentProvider>
    </PageCustomizationProvider>
  </NetworkProvider>
);

export default AppProviders;
